import { newRelicCall, transformArgumentsToString } from '~/helpers/log-helper';

const logByLevel = (_ref) => {
  let {
    level,
    message,
    isDev,
    customFilter = null
  } = _ref;
  if (!isDev) newRelicCall({
    msg: message,
    level,
    customFilter
  });
};

export default ((context, inject) => {
  // entrypoint for logging - for both SSR and CSR
  const isDebugModeEnabled = context.app && context.app.$cookies && context.app.$cookies.get('debugmdm');
  const logger = {
    debug: function debug(message) {
      for (var _len = arguments.length, theArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        theArgs[_key - 1] = arguments[_key];
      }

      logByLevel({
        level: 'debug',
        message: "".concat(message, " ").concat(transformArgumentsToString(theArgs)),
        isDev: context.isDev
      });
      if (context.isDev || isDebugModeEnabled) console.log(message, theArgs);
    },
    info: function info(message) {
      for (var _len2 = arguments.length, theArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        theArgs[_key2 - 1] = arguments[_key2];
      }

      logByLevel({
        level: 'info',
        message: "".concat(message, " ").concat(transformArgumentsToString(theArgs)),
        isDev: context.isDev
      });
      if (context.isDev || isDebugModeEnabled) console.info(message, theArgs);
    },
    warn: function warn(message) {
      for (var _len3 = arguments.length, theArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        theArgs[_key3 - 1] = arguments[_key3];
      }

      logByLevel({
        level: 'warn',
        message: "".concat(message, " ").concat(transformArgumentsToString(theArgs)),
        isDev: context.isDev
      });
      if (context.isDev || isDebugModeEnabled) console.warn(message, theArgs);
    },
    error: function error(message) {
      for (var _len4 = arguments.length, theArgs = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        theArgs[_key4 - 1] = arguments[_key4];
      }

      logByLevel({
        level: 'error',
        message: "".concat(message, " ").concat(transformArgumentsToString(theArgs)),
        isDev: context.isDev
      });
      if (context.isDev || isDebugModeEnabled) console.error(message, theArgs);
    },
    customFilter: function customFilter(message, _customFilter) {
      let level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'error';
      logByLevel({
        level,
        message,
        customFilter: _customFilter,
        isDev: context.isDev
      });
      if (context.isDev || isDebugModeEnabled) console.log(message);
    }
  };
  inject('logger', logger);
});